module.exports = __webpack_public_path__ + "img/box_10.84090386.png";